import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './Tag.module.css.js';

function Tag({ label, textColor, backgroundColor, uppercase, }) {
    return (jsx("div", { "aria-label": label, role: "note", className: styles.Tag, style: {
            backgroundColor,
        }, children: jsx("div", { className: clsx(styles.text, {
                [styles.uppercase]: uppercase,
            }), style: {
                color: textColor,
            }, children: label }) }));
}

export { Tag };
//# sourceMappingURL=Tag.js.map
